/* eslint-disable max-len */
import React from 'react'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'

import PatientProviderList from './Table/Index'
import MonitorViewTable from './MonitorViewTable/monitorViewTable'
import ObserverViewTable from './ObserverTable/PatientObserverTable'
import OtpPreferenceList from '../../../../components/OtpPreferenceList/OtpPreferenceList'

export default function ViewPatientDetails({data}) {
    
    return (
        <div className="h-[calc(100vh-382px)] overflow-auto scrollBar-hidden pr-2.5 mt-[26px] border border-[#E7CBD2] rounded-lg mx-[28px]" >
            <div className="w-full px-4 py-6">
                <section>
                    <div className='flex items-center mb-3.5'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Basic Details</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="flex -mx-1 flex-wrap">
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Username</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.user_name}</p>
                            </div>
                        </div>
                        <div className="w-2/3 px-1 mb-6">
                            <div className="w-full">
                                <div className="flex flex-wrap gap-x-12 gap-y-3 pt-2">
                                    <div className="flex flex-col gap-2">
                                        <p className="text-sm font-normal text-[#000000]">Alerts by SMS</p>
                                        <span className={`inline-flex items-center justify-center text-sm font-normal ${data[0]?.sms_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                            {data[0]?.sms_alert === true ? "ON" : "OFF"}
                                        </span>
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-sm font-normal text-[#000000]">Alerts by Email</p>
                                        <span className={`inline-flex items-center justify-center text-sm font-normal ${data[0]?.email_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                            {data[0]?.email_alert === true ? "ON" : "OFF"}
                                        </span>
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-sm font-normal text-[#000000]">Include Missed Readings</p>
                                        <span className={`inline-flex items-center justify-center text-sm font-normal ${data[0]?.missed_reading_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                            {data[0]?.missed_reading_alert === true ? "ON" : "OFF"}
                                        </span>
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-sm font-normal text-[#000000]">Receive Readings Acknowledgement</p>
                                        <span className={`inline-flex items-center justify-center text-sm font-normal ${data[0]?.reading_received_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                            {data[0]?.reading_received_alert === true ? "ON" : "OFF"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Email Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.email_address!==""?data[0]?.email_address:'-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.mobile_number!==""?data[0].country_code2+"\t"+formatMobileNumber(data[0]?.mobile_number):"-"}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Main Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0].country_code1} {formatMobileNumber(data[0].main_number)}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Date of Birth</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.date_of_birth!==""?data[0]?.date_of_birth:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Age</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.age!==""?data[0]?.age:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Gender</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.gender!==""?data[0]?.gender:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-full px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0].address!==""?data[0].address:'-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Primary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.primary_identifier!==""?data[0]?.primary_identifier:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Secondary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.secondary_identifier!==""?data[0]?.secondary_identifier:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Onboarding Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.onboarding_date!==""?data[0]?.onboarding_date:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="flex -mx-1">
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(kg)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {data[0]?.weight_kgs!==""?data[0]?.weight_kgs:'-'}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(lbs)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {data[0]?.weight_lbs!==""?data[0]?.weight_lbs:'-'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Patient Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.patient_status!==""?data[0]?.patient_status:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Timezone</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.timezone ? `${data[0]?.timezone}: (${data[0]?.abbreviation}) ${data[0]?.utcoffset}` : '-'}  
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0]?.monitoring_status!==""?data[0]?.monitoring_status:'-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Cycle Start Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {data[0] && (data[0].monitoring_cycle !== undefined && data[0].monitoring_cycle !== "") ? data[0].monitoring_cycle : '-'}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* otp list */}
                <OtpPreferenceList
                    username={data[0]?.user_name}
                />
                <section>
                    <div className='flex items-center mb-3.5'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Minimum Readings Conditions (By default {data[0]?.defaultReadings?.number_of_readings===""?"0":data[0]?.defaultReadings?.number_of_reading} readings in {data[0].defaultReadings?.number_of_time_periods===""?"0":data[0].defaultReadings?.number_of_time_periods} {data[0].defaultReadings?.time_period})</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className='bg-[#E5F3F3] rounded px-10 pt-3 pb-5 flex'>
                        <div className="w-fit xl:mr-[60px] mr-10">
                            <p className="text-sm font-normal text-[#000]">Readings</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {data[0]?.number_of_readings===""? "-" : data[0]?.number_of_readings}
                            </p>
                        </div>
                        <div className="w-fit xl:mr-[60px] mr-10">
                            <p className="text-sm font-normal text-[#000]">Number of Days</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {data[0]?.number_of_time_periods===""? "-" : data[0]?.number_of_time_periods}
                            </p>
                        </div>
                        <div className="w-fit">
                            <p className="text-sm font-normal text-[#000]">Time Period</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {data[0]?.time_period===""? "-" : data[0]?.time_period}
                            </p>
                        </div>
                    </div>
                </section>
                {(data[0]?.contacts?.length > 0 || data[0]?.case_managers?.length > 0) &&
                    <section>
                        <div className='flex items-center mb-3.5 mt-6'>
                            <h1 className='text-lg font-normal text-[#000000] min-w-max'>Additional Contact Details</h1>
                            <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                        </div>
                        <div className="flex -mx-[7px] flex-wrap">
                            
                            {data[0]?.contacts?.length > 0 &&
                                <div className="w-1/2 px-[7px]">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Emergency Contact Details (First entry is highest priority)</h1>
                                        <div className='px-2.5'>
                                            {data[0].contacts.map((contact, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !==0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.name !== "" ? contact.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.contact_number !== "" ?
                                                                    contact.country_code + "\t" + formatMobileNumber(contact.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data[0]?.case_managers?.length > 0 &&
                                <div className="w-1/2 px-[7px]">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Case Manager Contact Details (First entry is highest priority) </h1>
                                        <div className='px-2.5'>
                                            {data[0]?.case_managers.map((caseManager, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !==0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.name !== "" ? caseManager.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.contact_number !== "" ?
                                                                    caseManager.country_code + "\t" + formatMobileNumber(caseManager.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </section>
                }
                <section>
                    <div className='flex items-center mb-3.5 mt-6'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Organizational Assignment and User Associations</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    < div className='flex'>
                        <div>
                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {data[0].organization_name}
                            </p>
                        </div>
                        <div className="ml-[106px]">
                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {data[0].subdivision_name}
                            </p>
                        </div>
                    </div>

                </section>
                <section>
                    <MonitorViewTable
                        patient_id={data[0]?.patient_id}/>

                    <PatientProviderList 
                        patient_id={data[0]?.patient_id}                                                
                    />

                    <ObserverViewTable
                        patient_id={data[0]?.patient_id}
                    />
                </section>
            </div>
        </div>
    )
}
